export default __webpack_public_path__ + "static/reunion-6a0f356984648613b448e37b56aebe98.png";